import api from './axios';

export const getServiceCategories = async () => {
  const response = await api.get('/service/categories');
  return response.data;
};

export const getCategoryById = async (categoryId) => {
  const response = await api.get(`/categories/${categoryId}`);
  return response.data;
};

export const createService = async (serviceData) => {
  const response = await api.post('/service', serviceData);
  return response.data;
};

export const getVehicleServices = async (vehicleId) => {
  const response = await api.get(`/service/vehicle/${vehicleId}`);
  return response.data;
};

export const getServiceDetail = async (serviceId) => {
  const response = await api.get(`/service/${serviceId}`);
  return response.data;
};

export const deleteService = async (serviceId) => {
  const response = await api.delete(`/service/${serviceId}`);
  return response.data;
};

export const updateService = async (serviceId, serviceData) => {
  const response = await api.put(`/service/${serviceId}`, serviceData);
  return response.data;
};